import React from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { BatchStatusResponse } from '../../../types/results.types';

interface EnrichmentCompletionBannerProps {
  completion: BatchStatusResponse;
  onVerifyClick?: () => void;
  onExportClick?: () => void;
  onDismiss: () => void;
}

const EnrichmentCompletionBanner: React.FC<EnrichmentCompletionBannerProps> = ({
  completion,
  onVerifyClick,
  onExportClick,
  onDismiss,
}) => (
  <div className="mb-4 flex items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3">
    <div className="flex items-center gap-2.5 min-w-0">
      <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" />
      <p className="text-sm text-emerald-800">
        <span className="font-semibold">Enrichment complete</span>
        {' — '}
        {completion.succeeded} new email{completion.succeeded !== 1 ? 's' : ''} found
        {completion.failed > 0 && `, ${completion.failed} with no email`}.
      </p>
    </div>
    <div className="flex items-center gap-2 shrink-0">
      {onVerifyClick && completion.succeeded > 0 && (
        <button
          onClick={onVerifyClick}
          className="text-xs font-semibold text-emerald-700 hover:text-emerald-900 underline whitespace-nowrap"
        >
          Verify {completion.succeeded} →
        </button>
      )}
      {onExportClick && (
        <button
          onClick={onExportClick}
          className="text-xs font-semibold text-emerald-700 hover:text-emerald-900 underline whitespace-nowrap"
        >
          Export now
        </button>
      )}
      <button
        onClick={onDismiss}
        className="ml-1 rounded-md p-0.5 text-emerald-500 hover:text-emerald-700"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  </div>
);

export default EnrichmentCompletionBanner;
